import styled from 'styled-components';

const StyledLabel = styled.div`
    margin-bottom: 0.35rem;
`;

export default StyledLabel;
